export const formatDate = (date) => {

    return date.split(".").reverse().join('-')

}
